import { useSiteSettings } from "@/contexts/SiteSettingsContext";

/**
 * Branded "handing your cart to TheGameCrafter" state. Rendered on the
 * standalone /cart page summary panel (light background).
 */
const CheckoutLoading = ({ compact = false }: { compact?: boolean }) => {
  const { settings } = useSiteSettings();
  const title = settings.checkout_loading_title || "Securing your order";
  const message =
    settings.checkout_loading_message ||
    "We're handing your cart to TheGameCrafter, our printing partner. Checkout will open in a moment — please don't close this tab.";

  return (
    <div className={`flex flex-col items-center justify-center gap-4 px-6 text-center ${compact ? "" : "py-10"}`}>
      <div
        className="w-8 h-8 rounded-full border-2 border-[hsl(0,0%,75%)] border-t-[hsl(var(--blood-red))] animate-spin"
        aria-hidden="true"
      />
      <div className="flex flex-col items-center gap-2">
        <h1 className="text-[hsl(0,0%,10%)] uppercase tracking-[0.25em] text-sm font-semibold">{title}</h1>
        <p className="text-[hsl(0,0%,45%)] text-sm max-w-sm leading-relaxed">{message}</p>
      </div>
    </div>
  );
};

export default CheckoutLoading;
